import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const CompanyNumberManagementSlice = createSlice({
  name: "CompanyNumber",
  initialState: {},
  reducers: {},
});
export const getCompanyNumberManagementList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const resp = await api.post(
        API_URL.COMPANY_NUMBER_MENAGEMENT.LIST,
        payload
      );
      return Promise.resolve(resp.data);
    } catch (e: any) {
      return Promise.reject(e.data);
    }
  };
export const getCompaniesList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const resp = await api.post(
        API_URL.COMPANY_NUMBER_MENAGEMENT.COMPANIES,
        payload
      );
      return Promise.resolve(resp.data);
    } catch (e: any) {
      return Promise.reject(e.data);
    }
  };
export const CompanyNumberDetails =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const resp = await api.post(
        API_URL.COMPANY_NUMBER_MENAGEMENT.DETAILS,
        payload
      );
      return Promise.resolve(resp.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const FixBulkCompanyNumberCSV =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(
        API_URL.COMPANY_NUMBER_MENAGEMENT.FIX_CSV_INSERT,
        payload
      );
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const deleteCompanyNumberData =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(
        API_URL.COMPANY_NUMBER_MENAGEMENT.DELETE,
        payload
      );
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const exportFormCompanyNumberFields =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.get(API_URL.COMPANY_NUMBER_MENAGEMENT.EXPORT);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const exportCompanyNumberList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const resp = await api.post(
        API_URL.COMPANY_NUMBER_MENAGEMENT.EXPORT_DATA,
        payload
      );
      return Promise.resolve(resp.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export default CompanyNumberManagementSlice.reducer;
